module.exports = __webpack_public_path__ + "img/About_item_4.623bcc99.jpg";